module.exports = {"341226100":"慎城镇","341226101":"谢桥镇","341226102":"南照镇","341226103":"杨湖镇","341226104":"江口镇","341226105":"润河镇","341226106":"新集镇","341226107":"六十铺镇","341226108":"耿棚镇","341226109":"半岗镇","341226110":"王岗镇","341226111":"夏桥镇","341226112":"江店孜镇","341226113":"陈桥镇","341226114":"黄桥镇","341226115":"八里河镇","341226116":"迪沟镇","341226117":"西三十铺镇","341226118":"红星镇","341226119":"十八里铺镇","341226120":"鲁口镇","341226121":"古城镇","341226200":"建颍乡","341226201":"五十铺乡","341226202":"盛堂乡","341226203":"关屯乡","341226204":"垂岗乡","341226205":"赛涧回族乡","341226206":"刘集乡","341226207":"黄坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341226.json
// module id = 1126
// module chunks = 0